import { Box, Typography, CircularProgress, Link, Dialog, DialogTitle, DialogContent, DialogActions, Button, useMediaQuery, Grid } from "@material-ui/core";
import React from "react";
import { makeStyles, createStyles, Theme, useTheme } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        listKodePosInformationContainer: {
            marginTop: '15px',
            marginBottom: '-8px',
            borderRadius: '19px',
            border: "solid 1px rgb(209, 209, 209)",
            padding: "16px 13px",
            backgroundColor: "#fbfbfb",
            maxHeight: "40vh",
            // width: "80%",
            display: "flex",
            alignItems: 'center',
            // flexDirection: "column",
            [theme.breakpoints.up("lg")]: {
                width: "75%",
                borderRadius: '24px',
                padding: "13px 18px 10px 10px",
            },
        },
        listKodePosContainer: {
            marginTop: '3px',
            borderRadius: 12,
            border: "solid 1px rgb(109, 109, 109)",
            padding: "16px 20px",
            backgroundColor: "#f9f9f9",
            maxHeight: "40vh",
            width: "80%",
            display: "flex",
            flexDirection: "column",
            [theme.breakpoints.up("lg")]: {
                width: "50%",
            },
        },
        mainKelurahanText: {
            fontWeight: 400,
            color: '#000000',
            fontSize: '15px',
            letterSpacing: '0.4px',
            [theme.breakpoints.up("md")]: {
                fontSize: '15px',
            },
        },
        textEmoji: {
            fontWeight: 400,
            color: '#232323',
            fontSize: '26px',
            maxHeight: '23px',
            letterSpacing: '0.2px',
            [theme.breakpoints.up("md")]: {
                fontSize: '34px', 
                maxHeight: '28px',
            },
        },
        text: {
            fontWeight: 400,
            color: '#232323',
            fontSize: '11.5px',
            letterSpacing: '0.2px',
            [theme.breakpoints.up("md")]: {
                fontSize: '11.5px',
            },
        },
        andText: {
            fontSize: '10px',
            [theme.breakpoints.up("md")]: {
                fontSize: '10px',
            },
        },
        scrollContainer: {
            height: "90%",
            overflowY: "scroll",
            marginTop: '3px',
        },
        kodePosItem: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: "1px solid #ddd",
            borderRadius: '16px',
            padding: "10px 12px",
            marginBottom: "8px",
            cursor: "pointer",
            WebkitTapHighlightColor: 'transparent',
        },
        kodePosNumber: {
            fontWeight: 400,
            fontSize: '15px',
            padding: '4px 10.5px 1px',
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "1px solid black",
            borderRadius: 30,
            textAlign: "center",
        },
        kodePosNumberSelected: {
            backgroundColor: "black",
            color: "white",
        },
        kelurahanInfo: {
            marginLeft: "16px",
            flex: 1,
        },
        lihatSemuaLink: {
            fontSize: '10px',
            [theme.breakpoints.up("md")]: {
                fontSize: '10px',
            },
            marginTop: '2px',
            marginLeft: '3px',
            textUnderlineOffset: '2px',
            fontWeight: 500,
            color: "#333",
            cursor: "pointer",
            textDecoration: "underline",
        },
        dialogPaper: {
            borderRadius: 16,
        },
        kodePosBox: {
            border: "2px solid #000",
            borderRadius: "40px",
            padding: "6px 11px 3px",
            fontWeight: 600,
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        },
        kelurahanList: {
            backgroundColor: "#f2f2f2",
            borderRadius: "12px",
            padding: "16px",
            overflowY: "auto",
            height: "260px",
            flex: 1,
        },
        kelurahanItem: {
            fontSize: theme.spacing(1.5),
            padding: "6px 0",
            color: "#444",
        },
        dialogHeader: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
        dialogContent: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "16px",
            padding: '0px 18px 8px',
        },
        closeButton: {
            cursor: "pointer",
            fontSize: "20px",
            border: "none",
            background: "none",
        },
        okButton: {
            cursor: "pointer",
            margin: '10px 16px 20px 0px',
            padding: '3px 4px 1px',
            fontSize: "16px",
            widht: "30px",
            border: "1.25px solid black",
            borderRadius: 25,
        },
    })
);

interface KelurahanEntry {
    kodePos: string;
    daftarKelurahan: string[];
    kecamatanId: string;
}

interface Props {
    isLoading: boolean;
    kodePosList: KelurahanEntry[];
    onSelectKodePos: (kodePos: string) => void;
}

export default function ListKodePos({ isLoading, kodePosList, onSelectKodePos }: Props) {
    const classes = useStyles();
    const theme = useTheme();
    const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));
    const [open, setOpen] = React.useState(false);
    const [selectedKodePos, setSelectedKodePos] = React.useState<string>("");
    const [selectedKelurahan, setSelectedKelurahan] = React.useState<string[]>([]);
    const [selectedKodePosValue, setSelectedKodePosValue] = React.useState<string | null>(null);

    const handleLihatSemua = (kodePos: string, daftar: string[]) => {
        setSelectedKodePos(kodePos);
        setSelectedKelurahan(daftar);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setTimeout(() => {
            setSelectedKelurahan([]);
            setSelectedKodePos("");
        }, 200);
    };

    return (
        <Box className={classes.listKodePosContainer}>
            {
                isLoading ? 
                <Box style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', padding: '10px 0px'}}>
                    <CircularProgress/>
                </Box> :
                kodePosList.length === 0 ? (
                <Typography className={classes.text} variant="h5" gutterBottom>
                    Tidak ditemukan kode pos terkait
                </Typography>
            ) : (
                <>
                    <Typography className={classes.text} variant="h5" gutterBottom>
                        Mungkin ini kode pos kamu..
                    </Typography>

                    <Box className={classes.scrollContainer}>
                        {kodePosList.map((entry, index) => {
                            const mainKelurahan = entry.daftarKelurahan[0] || "-";
                            const mainKelurahan2 = entry?.daftarKelurahan?.[1];
                            const mainKelurahan3 = null; // entry?.daftarKelurahan?.[2];
                            const othersCount = entry.daftarKelurahan.length - 2;

                            return (
                                <Box
                                    key={index}
                                    className={classes.kodePosItem}
                                    onClick={() => {
                                        setSelectedKodePosValue(entry.kodePos);
                                        onSelectKodePos(entry.kodePos);
                                    }}
                                >
                                    <Typography className={`${classes.kodePosNumber} ${selectedKodePosValue === entry.kodePos ? classes.kodePosNumberSelected : ""}`}>{entry.kodePos}</Typography>
                                    <Box className={classes.kelurahanInfo}>
                                        <Typography className={classes.mainKelurahanText}>{mainKelurahan}</Typography>
                                        {
                                            mainKelurahan2 ? 
                                            <Typography className={classes.mainKelurahanText}>{mainKelurahan2}</Typography>:
                                            null
                                        }
                                        {
                                            mainKelurahan3 ? 
                                            <Typography className={classes.mainKelurahanText}>{mainKelurahan3}</Typography>:
                                            null
                                        }
                                        {othersCount > 0 && (
                                            <Typography className={classes.andText} variant="body2" color="textSecondary">
                                                dan {othersCount} Kelurahan lainnya{" "}
                                                {!isMdOrUp ? <br/> : null}
                                                <Link
                                                    className={classes.lihatSemuaLink}
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        handleLihatSemua(entry.kodePos, entry.daftarKelurahan);
                                                    }}
                                                >
                                                    + Lihat Semua
                                                </Link>
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>
                            );
                        })}
                    </Box>

                    {/* Dialog */}
                    <Dialog open={open} onClose={handleClose} classes={{ paper: classes.dialogPaper }} style={{zIndex: 1400}}>
                        <DialogTitle disableTypography>
                            <Box className={classes.dialogHeader}>
                                <Typography className={classes.text} variant="subtitle1">
                                    DAFTAR KELURAHAN DALAM KODE POS
                                </Typography>
                                <button onClick={handleClose} className={classes.closeButton}>
                                    <CloseIcon />
                                </button>
                            </Box>
                        </DialogTitle>
                        <DialogContent className={classes.dialogContent}>
                            <Typography className={classes.kodePosBox}>{selectedKodePos}</Typography>
                            <Box className={classes.kelurahanList}>
                                {selectedKelurahan.map((nama, idx) => (
                                    <Typography key={idx} className={classes.kelurahanItem}>
                                        {nama}
                                    </Typography>
                                ))}
                            </Box>
                        </DialogContent>

                        <DialogActions>
                            <Button
                                className={classes.okButton}
                                onClick={() => {
                                    handleClose();
                                    setSelectedKodePosValue(selectedKodePos);
                                    onSelectKodePos(selectedKodePos);
                                }}
                                variant="outlined"
                            >
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            )}
        </Box>
    );
}

export function ListKodePosEmpty() {
    const classes = useStyles();
    const theme = useTheme();
    const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));

    return (
        <Box className={classes.listKodePosContainer}>
            <Typography className={classes.text} style={{fontSize: '8.4px', marginBottom: '7px', color: '#444444'}} variant="h5" gutterBottom>
                FITUR SARAN KODE POS
            </Typography>
            <Typography className={classes.text} variant="h5" gutterBottom>
                <span style={{fontWeight: 500}}>Pilih kecamatan kamu,</span> dan daftar kode pos akan muncul disini!
            </Typography>
            <Box style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                <div style={{width: '5px', height: '5px', borderRadius: '5px', margin: '3px', backgroundColor: '#cacaca'}}></div>
                <div style={{width: '5px', height: '5px', borderRadius: '5px', margin: '3px', backgroundColor: '#cacaca'}}></div>
                <div style={{width: '5px', height: '5px', borderRadius: '5px', margin: '3px', backgroundColor: '#cacaca'}}></div>
            </Box>
        </Box>
    );
}

export function KodePosInformation() {
    const classes = useStyles();
    const theme = useTheme();
    const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));

    return (
        <Grid container className={classes.listKodePosInformationContainer}>
            <Grid item xs={2} style={{display: 'flex', justifyContent: 'center'}}>
                <Typography className={classes.textEmoji} variant="h5" gutterBottom>
                    🤔
                </Typography>
            </Grid>
            <Grid item xs={10}>
                <Typography className={classes.text} style={{fontSize: '14px'}}variant="h5" gutterBottom>
                    <span style={{fontWeight: 500}}>Agak lupa sama kode pos?</span>
                </Typography>
                <Typography className={classes.text} style={{fontSize: '10px', color: '#676767'}} variant="h5" gutterBottom>
                    <span style={{fontWeight: 500}}>Pilih kecamatan kamu,</span> dan daftar kode pos daerah kamu akan muncul!
                </Typography>
            </Grid>
        </Grid>
    );
}
